module.exports = __webpack_public_path__ + "img/support.0d9aaa81.svg";